import Havena1 from "./H10x18 (1).webp";
import Havena2 from "./H10x18 (2).webp";
import Havena3 from "./H10x18 (3).webp";
import Havena4 from "./H10x18 (4).webp";
import Havena5 from "./H10x18 (5).webp";
import Havena6 from "./H10x18 (6).webp";
import Havena7 from "./H10x18 (7).webp";
import Havena8 from "./H10x18 (8).webp";

const Havena10Atticimages = [
  Havena1,
  Havena2,
  Havena3,
  Havena4,
  Havena5,
  Havena6,
  Havena7,
  Havena8,
];

export default Havena10Atticimages;
